import React, { useState, useEffect } from 'react';
import { Formik, Form, useFormikContext } from 'formik';
import * as Yup from 'yup';
import { Flex, Button, useToast } from '@chakra-ui/react';
import Card from 'components/card/Card';
import { useSelectedPermissions } from 'contexts/PermissionGroupArrayContext';
import PermissionGroupApi from 'api/permissiongroup';
import InputField from 'components/formComponents/inputField';
import SelectionTables from './selectionTables';
import { PermissionGroupValidationSchema } from 'formValidations/permissionGroupFormValidations';
import { useHistory } from 'react-router-dom';
import { usePermissions } from 'contexts/PermissionContext';
import { Modules } from 'config/constant';
import NoPermissionsMessage from 'components/nopermission/NoPermissions';

const NameField = ({ disabled }) => {
  const { values, setFieldValue } = useFormikContext();
  const [name, setName] = useState(values.name);

  useEffect(() => {
    setFieldValue('name', name);
  }, [name, setFieldValue]);

  useEffect(() => {
    setName(values.name);
  }, [values.name]);

  return (
    <InputField
      label='Name of the Permission Group'
      required={true}
      name='name'
      type='text'
      value={name}
      onChange={(e) => setName(e.target.value)}
      disabled={disabled}
    />
  );
};

const AddPermissionGroupForm = () => {
  const history = useHistory();
  const toast = useToast();
  const toastIdRef = React.useRef();
  const initialRef = React.useRef(null);
  const finalRef = React.useRef(null);
  const { selectedPermissions, resetSelectedPermissions } =
    useSelectedPermissions();
  const getIdArray = (permissions) =>
    permissions.map((permission) => permission.id);
  const [key, setKey] = useState(0);

  const reloadChild = () => setKey((prevKey) => prevKey + 1);

  const initialValues = {
    name: '',
  };

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    if (toastIdRef.current) {
      toast.close(toastIdRef.current);
    }
    console.log(
      'values from permissionGroup',
      values,
      getIdArray(selectedPermissions)
    );
    try {
      let response = await PermissionGroupApi.Create({
        ...values,
        idArray: getIdArray(selectedPermissions),
      });
      response = response.data;
      if (response.status_code === 200) {
        toastIdRef.current = toast({
          title: response.message || 'Successfully Added',
          status: 'success',
          duration: 5000,
          isClosable: true,
          position: 'top',
        });
        resetSelectedPermissions();
        reloadChild();
        resetForm({
          values: {
            name: '',
          },
        });
        history.push('/admin/permissiongroups');
      } else {
        toastIdRef.current = toast({
          title: response.message || 'Error Adding',
          status: 'error',
          duration: 5000,
          isClosable: true,
          position: 'top',
        });
      }
    } catch (err) {
      toastIdRef.current = toast({
        title: 'Unable to Add',
        status: 'error',
        duration: 5000,
        isClosable: true,
        position: 'top',
      });
      console.log(err);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Flex height='100%' mt='7rem' direction='column'>
      <Formik
        initialValues={initialValues}
        validationSchema={PermissionGroupValidationSchema}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {({ isSubmitting }) => (
          <Form noValidate>
            <Card bgColor='gray.200' maxWidth='5xl'>
              <NameField disabled={isSubmitting} />
            </Card>
            <SelectionTables key={key} />

            {selectedPermissions.length < 1 ? (
              <Button mt={20} colorScheme='blue' disabled type='submit'>
                Please Select atleast 1 Permission
              </Button>
            ) : (
              <Button
                mt={20}
                colorScheme='blue'
                type='submit'
                isLoading={isSubmitting}
              >
                Add New Permission Group
              </Button>
            )}
          </Form>
        )}
      </Formik>
    </Flex>
  );
};

export default AddPermissionGroupForm;
